import { PhoneIncoming, CalendarCheck, MapPin, Wrench, CreditCard, Star } from "lucide-react";
import Reveal from "../Reveal";

const STEPS = [
  { icon: PhoneIncoming, title: "Call or lead comes in", body: "Incoming calls match to existing customers instantly; web lead forms create new ones for you." },
  { icon: CalendarCheck, title: "Job created & dispatched", body: "Book the job on the calendar and assign the right technician — they're notified by SMS and push." },
  { icon: MapPin, title: "Tech arrives on-site", body: "One-tap navigation, full job details, and an on-site estimate the customer can approve with a signature." },
  { icon: Wrench, title: "Work gets done", body: "Status updates, photos, and notes sync back to the office in real time." },
  { icon: CreditCard, title: "Invoice & payment", body: "Convert the estimate to an invoice and take a card payment on the spot or by text link." },
  { icon: Star, title: "Receipt & review request", body: "The customer gets an automatic receipt, then a review request to grow your reputation." },
];

const WorkflowTimeline = () => (
  <section id="workflow" className="bg-[var(--mk-bg-3)] py-16 md:py-24 border-y border-slate-100" data-testid="workflow-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-2xl mb-14">
        <p className="text-xs uppercase tracking-[0.22em] font-semibold text-[var(--mk-blue)] mb-4">How it works</p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-[1.2] mb-4">
          From first call to final payment
        </h2>
        <p className="text-lg text-slate-600 leading-relaxed">
          The whole job lifecycle runs through one system — nothing gets copied between apps, nothing gets lost.
        </p>
      </Reveal>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={Math.min((i % 3) + 1, 5)}>
            <div className="relative h-full rounded-2xl bg-white border border-slate-200 p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_16px_32px_-12px_rgba(15,23,42,0.14)]" data-testid={`workflow-step-${i + 1}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-xl bg-[var(--mk-blue-light)] flex items-center justify-center">
                  <s.icon className="w-5 h-5 text-[var(--mk-blue)]" />
                </div>
                <span className="text-[13px] font-bold text-slate-400 tracking-wide">STEP {i + 1}</span>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">{s.title}</h3>
              <p className="text-[14.5px] text-slate-600 leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WorkflowTimeline;
